var _circle, _path, _path2, _path3, _path4, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLonely(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22 Q17 21 18 22",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22 Q31 21 32 22",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32 Q24 30 28 32",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38 L24 42",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 36,
    r: 4,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 4,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLonely);
export default __webpack_public_path__ + "static/media/lonely.9bb8332a221413c6d315d54a721fdd33.svg";
export { ForwardRef as ReactComponent };